import {inject, Injectable} from '@angular/core';
import {BaseService} from '../services/base.service';
import {AdministrationRoleService} from '@gnv-swagger/core/secured';
import {fetchAllPaginated} from '../shared/utils/call-api/api-query.utils';
import {DEFAULT_PAGE_SIZE} from '@gnv-shared/constants';
import {Role} from 'swagger-gen/gnvert-secured/models/role';

@Injectable({
  providedIn: 'root',
})
export class AdministrationRepo extends BaseService {
  private readonly adminRoleService = inject(AdministrationRoleService)

  getAllRoles() {
    return fetchAllPaginated<Role>(
      (offset, limit) =>
        this.adminRoleService.searchCustomRoleList$Json({ offset: offset, limit: limit, body: {} }),
      DEFAULT_PAGE_SIZE
    );
  }

}
